import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeFour/f5.png'



export default /*@__PURE__*/_defineComponent({
  __name: 'floatButton2',
  setup(__props) {

const scrollToTop = () => {
    document.getElementById('top-of-home-page')?.scrollIntoView({ behavior: 'smooth' });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: scrollToTop
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)
  ])))
}
}

})